import { React, useState, useEffect,useRef } from "react";
import "../ImportExport/ServicePages.css";
import ContactPopup from "../ContactPopup";

const GSTReturnFiling = () => {
   const [openPopup, setOpenPopup] = useState(false);

   const contactRef = useRef(null);

    const scrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
    }

  useEffect(() => {
    document.title = "GST Return Filing Service | GSTR-1, GSTR-3B, GSTR-9 Filing India";

    const meta = document.createElement("meta");
    meta.name = "description";
    meta.content =
      "File GST returns online with expert help. GSTR-1, GSTR-3B, GSTR-9 filing services with ITC optimization and compliance support in India.";
    document.head.appendChild(meta);
  }, []);

  return (
    <div className="service-page">

      {/* HERO */}
      <section className="service-hero">
        <h1>GST Return Filing Service</h1>
        <p>Accurate & Timely GST Compliance for Businesses in India</p>
        <button className="hero-btn" onClick={scrollToContact}>
                        Get Started Today
                    </button>
      </section>

      {/* OVERVIEW */}
      <section className="service-section">
        <h2>Overview</h2>
        <p>
          GST return filing is a mandatory compliance for all registered taxpayers under GST.
          It involves reporting your sales, purchases, tax collected, and tax paid to the government.
        </p>
        <p>
          Timely and accurate GST filing ensures your business stays compliant,
          avoids penalties, and maintains smooth operations.
        </p>
      </section>

      {/* WHO NEEDS */}
      <section className="service-section">
        <h2>Who Needs to File GST Returns?</h2>
        <div className="card">Regular Taxpayers</div>
        <div className="card">GST Registered Businesses</div>
        <div className="card">E-commerce Sellers</div>
        <div className="card">Service Providers</div>
        <div className="card">Traders & Manufacturers</div>
        <p style={{ marginTop: "10px", color: "gray" }}>
          Even if there is no business activity, NIL return filing is mandatory.
        </p>
      </section>

      {/* TYPES */}
      <section className="service-section">
        <h2>Types of GST Returns We Handle</h2>

        <div className="card">GSTR-1 – Sales (Outward Supplies)</div>
        <div className="card">GSTR-3B – Monthly Summary Return</div>
        <div className="card">GSTR-9 – Annual Return</div>
        <div className="card">GSTR-4 – Composition Scheme Return</div>
        <div className="card">GSTR-9C – Reconciliation Statement</div>

      </section>

      {/* SERVICES */}
      <section className="service-section">
        <h2>Our GST Filing Services Include</h2>
        <ul>
          <li>Preparation and filing of GST returns</li>
          <li>Data reconciliation (Sales & Purchases)</li>
          <li>Input Tax Credit (ITC) optimization</li>
          <li>NIL return filing</li>
          <li>Late filing / pending return support</li>
          <li>GST compliance review</li>
          <li>Handling notices & queries</li>
        </ul>
      </section>

      {/* DUE DATES */}
      <section className="service-section">
        <h2>Due Dates (General)</h2>
        <div className="card">
          <ul>
            <li>GSTR-1: Monthly / Quarterly</li>
            <li>GSTR-3B: Monthly</li>
            <li>GSTR-9: Annually</li>
          </ul>
          <p style={{ color: "gray" }}>
            Due dates may vary based on turnover and scheme.
          </p>
        </div>
      </section>

      {/* PENALTY */}
      <section className="service-section">
        <h2>Penalties for Late Filing</h2>
        <div className="card" style={{ background: "#fff3f3", border: "1px solid #ffcccc" }}>
          <ul>
            <li>Late fees (₹50 per day / ₹20 for NIL returns)</li>
            <li>Interest on outstanding tax</li>
            <li>Blocking of e-way bill generation</li>
          </ul>
        </div>
      </section>

      {/* IMPORTANCE */}
      <section className="service-section">
        <h2>Why GST Filing is Important?</h2>
        <ul>
          <li>✔ Avoid penalties and legal issues</li>
          <li>✔ Claim Input Tax Credit (ITC)</li>
          <li>✔ Maintain business compliance</li>
          <li>✔ Build credibility with clients</li>
          <li>✔ Smooth business operations</li>
        </ul>
      </section>

      {/* DOCUMENTS */}
      <section className="service-section">
        <h2>Documents Required</h2>
        <div className="card">GST Login Credentials</div>
        <div className="card">Sales & Purchase Invoices</div>
        <div className="card">Bank Statements</div>
        <div className="card">Previous GST Returns (if any)</div>
      </section>

      {/* WHY US */}
      <section className="service-section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>✔ Experienced GST professionals</li>
          <li>✔ Accurate & timely filing</li>
          <li>✔ ITC maximization</li>
          <li>✔ Affordable pricing</li>
          <li>✔ Dedicated support</li>
        </ul>
      </section>

      {/* CTA */}
      {/* <section className="cta" ref={contactRef}>
        <h2>Stay GST Compliant Without Stress</h2>
        <p>Let our experts handle your GST return filing.</p>
        <button onClick={() => setOpenPopup(true)} 
>Get Started</button>
 <ContactPopup
        isOpen={openPopup}
        onClose={() => setOpenPopup(false)}
      />
      </section>

      <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button> */}

          <div className="cta" ref={contactRef}>
              <h2>Stay GST Compliant Without Stress</h2>
              <p>Let our experts handle your GST return filing.</p>
      
              <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Get Started</button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>
            </div>

    </div>
  );
};

export default GSTReturnFiling;